import { Icon } from '@iconify/react';
import React from 'react';

export default function ContactInfoWidget({ data }) {
  return (
    <ul className='cs_contact_widget'>
      <li
        style={{
          whiteSpace: 'pre-line',
        }}
      >
        <i className='cs_accent_bg'>
          <Icon icon='ep:location' />
        </i>
        {data?.address || ''}
      </li>
      <li>
        <i className='cs_accent_bg'>
          <Icon icon='fluent:call-24-regular' />
        </i>
        {data?.phone || ''}
      </li>
      {data?.email && (
        <li>
          <i className='cs_accent_bg'>
            <Icon icon='bi:envelope' />
          </i>
          {data?.email || ''}
        </li>
      )}
    </ul>
  );
}
